import React from "react";
import TextInput from "../input/textinput.js";
export default function TextInputComponent(props) {
    const { component } = props;
    return (React.createElement("div", { id: component.id, className: "flow-common-component " +
            (props.isOutlined ? "flow-component-outlined" : "") },
        React.createElement(TextInput, { placeholder: component.placeholder, label: component.label, classNames: "input-labels", onChange: (value) => props.onChange({
                [component.id]: { value, inputName: component.fieldName },
            }), validator: (value) => {
                var _a;
                const result = ((_a = component.extraCheck) === null || _a === void 0 ? void 0 : _a.regex) ?
                    new RegExp(component.extraCheck.regex).test(value)
                    : true;
                return result === true ?
                    [result, ""]
                    : [result, component.extraCheck.errorMessage];
            } })));
}
